import { EXPLORER_LINK } from 'modules/api/const';

export function getTransactionDetailsLink(txId: string) {
  // eslint-disable-next-line no-template-curly-in-string
  return `${EXPLORER_LINK}/tx/${txId}`;
}
